import React, { useState, useEffect } from "react";
import Alert from "react-s-alert";
import { Col, Image, Row, Button, Modal } from "react-bootstrap";
import { IconButton } from "@material-ui/core";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
// import Switch from "react-switch";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Media from "react-media";

import { useFormik } from "formik";
import * as yup from "yup";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { useHistory } from "react-router";

export const TableManagementScreen = (props) => {
  const [disabled, setDisabled] = useState(props.location?.state?.access);
  const history = useHistory();

  /*************************************
   * @DESC Remove TaxName Change Handlers
   ************************************/
  const removeFloorAndSection = () => {
    let letFloorData = formik.values.floors;
    let letTableData = formik.values.table;
    let letSeatData = formik.values.seat;

    // code for removing table
    let removeFloorData;
    removeFloorData = letFloorData.filter((item, index) => {
      return activeIndex !== index;
    });

    // code for removing data from table array  added for that floor number and area

    let removeDataForFloorArea = [];
    for (let i = 0; i < letTableData.length; i++) {
      if (
        letTableData[i].floor_number === floorNumber &&
        letTableData[i].area === areaNo
      ) {
        // dont append this data as we should delete this from table array
      } else {
        removeDataForFloorArea.push(letTableData[i]);
      }
    }

    // code for removing data from seat array  added for that floor number and area

    let removeDataForSeatArea = [];
    for (let i = 0; i < letSeatData.length; i++) {
      if (
        letSeatData[i].floor_number === floorNumber &&
        letSeatData[i].area === areaNo
      ) {
        // dont append this data as we should delete this from table array
      } else {
        removeDataForSeatArea.push(letSeatData[i]);
      }
    }

    setFloorNo("");
    setAreaNo("");
    handleCloseDeleteItem();

    formik.setFieldValue("floors", removeFloorData);
    formik.setFieldValue("table", removeDataForFloorArea);
    formik.setFieldValue("seat", removeDataForSeatArea);
  };
  const [activeIndex, setActiveIndex] = useState();
  const [deleteItem, setDeleteItem] = useState(false);
  const [floorNumber, setFloorNo] = useState("");
  const [areaNo, setAreaNo] = useState("");
  const handleCloseDeleteItem = () => setDeleteItem(false);
  const handleshowDeleteItem = (index, floorNo, area) => {
    setActiveIndex(index);
    setFloorNo(floorNo);
    setAreaNo(area);
    setDeleteItem(true);
  };

  const onClickEditFloorArea = (data, index) => {
    setActiveIndex(index);
    formikAddNewFloorSeats.setFieldValue("floor_number", data.floor_number);
    formikAddNewFloorSeats.setFieldValue("area", data.area);
    setFloorNo(data.floor_number);
    setAreaNo(data.area);
  };

  const [showHide, setShowHide] = useState(true);

  const onClickAddFloor = (e) => {
    e.preventDefault();
    formikAddNewFloorSeats.handleSubmit();
  };

  const formikAddNewFloorSeats = useFormik({
    initialValues: {
      floor_number: "",
      area: "",
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please enter floor number "),
      area: yup.string().required("Please enter section name / area "),
    }),

    onSubmit: (values) => {
      let floorData = formik.values.floors;

      let checkItemExists = false;

      for (let i = 0; i < floorData.length; i++) {
        if (
          values.floor_number === floorData[i]?.floor_number &&
          values.area === floorData[i]?.area
        ) {
          checkItemExists = true;
          Alert.error(`<h4>You have already added this area /section</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        }
      }

      if (!checkItemExists) {
        if (activeIndex >= 0) {
          floorData[activeIndex] = values;

          // here we are updating values from actual table seat data
          let allTableData =
            props?.allSubscriptionData?.casual_dining_status?.seating
              ?.table_management?.table_setup?.table;
          let allSeatData =
            props?.allSubscriptionData?.casual_dining_status?.seating
              ?.table_management?.table_setup?.seat;
          let updateForTable = [];
          let updateForSeat = [];

          for (let i = 0; i < allTableData.length; i++) {
            if (
              allTableData[i].floor_number == floorNumber &&
              allTableData[i].area == areaNo
            ) {
              let data = allTableData[i];
              data.floor_number = values.floor_number;
              data.area = values.area;
              updateForTable.push(data);
            } else {
              updateForTable.push(allTableData[i]);
            }
          }
          formik.setFieldValue("table", updateForTable); // update table data

          for (let i = 0; i < allSeatData.length; i++) {
            if (
              allSeatData[i].floor_number == floorNumber &&
              allSeatData[i].area == areaNo
            ) {
              let data = allSeatData[i];
              data.floor_number = values.floor_number;
              data.area = values.area;
              updateForSeat.push(data);
            } else {
              updateForSeat.push(allSeatData[i]);
            }
          }
          formik.setFieldValue("seat", updateForSeat); // update seat data
        } else {
          floorData.push(values);
        }
        formik.setFieldValue("floors", floorData);
        formikAddNewFloorSeats.resetForm();
        setActiveIndex();
        setFloorNo("");
        setAreaNo("");
      }
    },
  });

  const onClickNext = () => {
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: {
      standard: true,
      floors: [],
      seat: [],
      table: [],
    },

    onSubmit: (values) => {
      if (values.floors.length === 0) {
        Alert.error(`<h4>Please add atleast one floor/seat section</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        const formData = props?.allSubscriptionData;
        formData.casual_dining_status.seating.table_management.table_setup =
          values;

        const token = props?.auth?.user?.accessToken;
        const subscriptionId = props?.subscription?._id;
        props.update_new_subscription_for_vendor(
          subscriptionId,
          formData,
          token,
          onSuccess
        );
      }
    },
  });
  const onSuccess = (e) => {
    history.push("/casual-fine-dining/seatingmanagement/tableseatmanagement");
  };

  useEffect(() => {
    let data = props?.allSubscriptionData;

    if (
      data &&
      data?.casual_dining_status &&
      data?.casual_dining_status?.seating &&
      data?.casual_dining_status?.seating?.table_management?.table_setup
    ) {
      formik.setValues(
        data?.casual_dining_status?.seating?.table_management?.table_setup
      );
      formik.setFieldValue("standard", true); // no to expicitly give true as coming false from api response
    }
  }, [props?.allSubscriptionData]);

  return (
    <React.Fragment>
      {props?.auth?.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      backButtonClicked={
                        "/casual-fine-dining/seatingmanagement"
                      }
                      notDisplaProgressBar={true}
                    />
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={true}
                    onLink={"/casual-fine-dining/seatingmanagement"}
                  />
                </Media>
                <div className="onboarding_process_screen-button-map inside-subscription-event-section">
                  <div>
                    <TopTextReusableComponent
                      headingText="Table / Seat Management"
                      headingParagraph="(Enter these details carefully if you wish to have a table management to manage seat assignment, add floors in the Restaurant, then you will be asked to. Add sections to which you can add tables)"
                    />
                  </div>
                  <div className="f14-700 py-4">
                    Do you have standard table management or custom table
                    management?
                  </div>
                  <div className="d-flex flex-wrap">
                    <label className="enRadioWithText small mr-4 mb-4">
                      <span className="f14-500">Standard</span>
                      <input
                        type="radio"
                        name="tablManagement"
                        disabled={disabled}
                        value="Standard"
                        checked={formik.values.standard}
                        //onChange={props.handleCheckbox}
                        //onClick={props.handleCheckboxRemove}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label className="enRadioWithText small mr-4 mb-4">
                      <span className="f14-500">
                        Custom ( Not Available at this time)
                      </span>
                      <input
                        type="radio"
                        name="tablManagement"
                        value="Custom"
                        disabled={disabled}
                        disabled
                        checked={formik.values.standard === false}
                        //onChange={props.handleCheckbox}
                        //onClick={props.handleCheckboxRemove}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <hr className="mb-1" />
                  <hr className="mt-0" />
                  <div className="f20-500 pb-4">
                    Add Floor and Section information
                  </div>
                  <Row>
                    <Col xl={5} className="pb-4 pr-0">
                      <NewInputText
                        extraClass={`m-1 ${
                          formikAddNewFloorSeats.errors.floor_number &&
                          formikAddNewFloorSeats.touched.floor_number
                            ? "enError"
                            : ""
                        }`}
                        disabled={disabled}
                        labelText="Floor Number / Seating Area"
                        inputType="text"
                        name="floor_number"
                        onChange={formikAddNewFloorSeats.handleChange}
                        value={formikAddNewFloorSeats.values.floor_number}
                        onFocusOut={formikAddNewFloorSeats.handleBlur}
                      />
                      {formikAddNewFloorSeats.errors.floor_number &&
                      formikAddNewFloorSeats.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikAddNewFloorSeats.errors.floor_number}
                        </div>
                      ) : null}
                    </Col>
                    <Col xl={5} className="pb-4 pr-0">
                      <NewInputText
                        extraClass={`m-1 ${
                          formikAddNewFloorSeats.errors.area &&
                          formikAddNewFloorSeats.touched.area
                            ? "enError"
                            : ""
                        }`}
                        labelText="Section Name/Number"
                        inputType="text"
                        disabled={disabled}
                        name="area"
                        onChange={formikAddNewFloorSeats.handleChange}
                        value={formikAddNewFloorSeats.values.area}
                        onFocusOut={formikAddNewFloorSeats.handleBlur}
                      />
                      {formikAddNewFloorSeats.errors.area &&
                      formikAddNewFloorSeats.touched.area ? (
                        <div className="pho_14_regular text-danger">
                          {formikAddNewFloorSeats.errors.area}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <Button
                    variant="link"
                    className="d-flex align-items-center p-0 mb-4"
                    onClick={(e) => onClickAddFloor(e)}
                    disabled={disabled}
                  >
                    <Image
                      src={require("../../../../../../../assets/images/UserManagement/add-blue.svg")}
                      alt="add"
                      title="add"
                      className="w-20px"
                    />
                    <span className="ml-2 f12-500 text-blue">
                      Add another Floor and Section details
                    </span>
                  </Button>
                  {formik.values.floors.length !== 0 ? (
                    <div className="mt-5">
                      <Button
                        variant="link"
                        disabled={disabled}
                        className="d-flex align-items-center text-red p-0 mb-4"
                        //onClick={handleToggleFloorsSection}
                        onClick={() => setShowHide(!showHide)}
                      >
                        <span className="f12-500 text-red">
                          {showHide ? "Hide" : "Show"} Floors and Sections
                        </span>
                        <KeyboardArrowDownIcon />
                      </Button>
                    </div>
                  ) : (
                    <> </>
                  )}
                  {formik.values.floors.length !== 0 ? (
                    <>
                      {showHide ? (
                        <Row className="align-items-center">
                          <Col md={4} xs={4}>
                            <div className="f16-500 py-2">Floor</div>
                          </Col>
                          <Col md={3} xs={3}>
                            <div className="f16-500 py-2">Section</div>
                          </Col>
                        </Row>
                      ) : (
                        <> </>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                  {showHide ? (
                    <React.Fragment>
                      {formik.values.floors.map((data, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Row className="align-items-center pb-4">
                              <Col md={4} xs={4}>
                                <div className="f14-400 py-2">
                                  {data.floor_number}
                                </div>
                              </Col>
                              <Col md={3} xs={4}>
                                <div className="f14-400 py-2">{data.area}</div>
                              </Col>
                              <Col md={3} xs={4}>
                                <div className="d-flex align-items-center">
                                  <IconButton
                                    className="mr-2"
                                    disabled={disabled}
                                  >
                                    <Image
                                      src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                      alt="edit "
                                      title="edit"
                                      className="w-20px"
                                      onClick={(e) =>
                                        onClickEditFloorArea(data, index)
                                      }
                                    />
                                  </IconButton>
                                  <IconButton
                                    disabled={disabled}
                                    onClick={(e) =>
                                      handleshowDeleteItem(
                                        index,
                                        data.floor_number,
                                        data.area
                                      )
                                    }
                                  >
                                    <Image
                                      src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                      alt="delete "
                                      title="delete"
                                      className="w-20px"
                                    />
                                  </IconButton>
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  ) : (
                    <></>
                  )}
                  <Modal
                    show={deleteItem}
                    onHide={handleCloseDeleteItem}
                    centered
                  >
                    <Modal.Header className="py-0 pt-2 border-0" closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="f16-500">
                      Are you sure to delete this floor/section ?
                    </Modal.Body>
                    <Modal.Footer className="justify-content-start border-0">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={handleCloseDeleteItem}
                      >
                        No
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={removeFloorAndSection}
                      >
                        Yes
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <div className="onboarding-map-setup-screen-autodetect-button ">
                    <ReusableOnboardingButton
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      buttonType="button"
                      // onClick={props.insideSeatingTableBackClick}
                      onClick={() =>
                        history.push("/casual-fine-dining/seatingmanagement")
                      }
                    />
                    {!disabled && (
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Next"
                        buttonType="button"
                        //onClick={props.insideSeatingTableSubmitClick}
                        onClick={() => onClickNext()}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={false}
                  displayHamburger={true}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

TableManagementScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  subscriptionData:
    state?.onboarding &&
    state?.onboarding?.onboard_subscription_details &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ?.ordering &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ?.ordering?.table_management,
  allSubscriptionData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(TableManagementScreen));
